import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "option-list__header"
}
const _hoisted_2 = { class: "option-list__list-items" }
const _hoisted_3 = { class: "option-list__empty-sign" }
const _hoisted_4 = {
  key: 1,
  class: "option-list__bottom"
}

import { useDetectOutsideClick } from "tir-components/composables";
import { TirPmScrollbar } from "tir-pm-scrollbar";
import { PropType, computed, ref, useSlots, watch } from "vue";
import { TirPmOptionListPositionEnum } from "./enums";

// const emit = defineEmits<{
//   (eventName: "toggleVisibleOptions", value: boolean): void;
// }>();

interface IPosition {
  x?: TirPmOptionListPositionEnum;
  y?: TirPmOptionListPositionEnum;
}

/**
 * Есть ли слот для хедера
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmOptionList',
  props: {
  /**
   * Максимальная высота
   */
  maxHeight: { type: Number as PropType<number>, default: 240 },

  /**
   * Открыто
   */
  isOpened: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Ширина
   */
  width: {
    type: Number as PropType<number | string>,
  },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Надпись если нет выриантов выбора
   */
  isWithoutOptionLabel: {
    type: String as PropType<string>,
    default: "Пока ничего нет",
  },
  /**
   * Использовать ли клик-оутсайд для закрытия окна
   */
  isUseClickOutside: { type: Boolean as PropType<boolean>, default: true },
  /**
   * Позиция по горизонтали
   */
  horizontalPosition: {
    type: Object as PropType<IPosition>,
    required: false,
    default(): IPosition {
      return {};
    },
  },
  verticalPosition: {
    type: Object as PropType<IPosition>,
    required: false,
    default(): IPosition {
      return {};
    },
  },
},
  emits: ["checkOpenOptions"],
  setup(__props, { emit: emits }) {

const props = __props;

const slots = useSlots();

const optionListHeader = computed(
  () => slots && slots.optionListHeader && slots.optionListHeader()
);
/**
 * Есть ли слот для футера
 */
const optionListBottom = computed(
  () => slots && slots.optionListBottom && slots.optionListBottom()
);

const optionListContainer = ref(null);

/**Отправка состояния видимости опций */

/**
 * Пропсы
 */


const isOpenedLocal = ref(props.isOpened);

const closePopup = () => {
  isOpenedLocal.value = false;
};

watch(
  () => props.isOpened,
  (newState) => {
    isOpenedLocal.value = newState;
  }
);

watch(
  () => isOpenedLocal.value,
  () => {
    emits("checkOpenOptions", isOpenedLocal.value);
  }
);
/**
 * Выведение класса для позиционирования
 */
const calculatePosition = computed(() => {
  if (Object.keys(props.horizontalPosition).length) {
    return `option-list--${props.horizontalPosition.x}-${props.horizontalPosition.y}-horizontal-position`;
  } else if (Object.keys(props.verticalPosition).length) {
    return `option-list--${props.verticalPosition.x}-${props.verticalPosition.y}-vertical-position`;
  } else {
    return "option-list--full-width-bottom";
  }
});

if (props.isUseClickOutside) {
  useDetectOutsideClick(optionListContainer, () => {
    isOpenedLocal.value = false;
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "option-list-container",
    ref_key: "optionListContainer",
    ref: optionListContainer
  }, [
    _createElementVNode("div", {
      class: "option-list-container-target",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpenedLocal.value = !isOpenedLocal.value))
    }, [
      _renderSlot(_ctx.$slots, "optionListTarget", { isOpened: isOpenedLocal.value })
    ]),
    _createVNode(_Transition, { name: "option-list" }, {
      default: _withCtx(() => [
        (isOpenedLocal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["option-list", [calculatePosition.value]]),
              style: _normalizeStyle({
          width: props.width / 16 + 'rem',
        }),
              ref: "optionList"
            }, [
              (optionListHeader.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "optionListHeader")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(TirPmScrollbar), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "option-list__items",
                      style: _normalizeStyle({
                maxHeight: props.maxHeight / 16 + 'rem',
              })
                    }, [
                      _renderSlot(_ctx.$slots, "content", { close: closePopup }, () => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(props.isWithoutOptionLabel), 1)
                      ])
                    ], 4)
                  ]),
                  _: 3
                })
              ]),
              (optionListBottom.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "optionListBottom")
                  ]))
                : _createCommentVNode("", true)
            ], 6))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 512))
}
}

})